module.exports = "<div data-bind=\"text: question.koProgressText, css: question.koCss().progressText\"></div>";